import { ReactComponent as CursorArrow } from 'approot/shared/icons/icon_cursor_arrow.svg';
import Icon, { IconProps } from './icon';

const IconCursorArrow = (props: IconProps & { id?: string }) => {
  return <Icon {...props} Svg={CursorArrow} />;
};

export default IconCursorArrow;
